import script from "./AppBreadcrumbs.vue?vue&type=script&setup=true&lang=js"
export * from "./AppBreadcrumbs.vue?vue&type=script&setup=true&lang=js"

import "./AppBreadcrumbs.vue?vue&type=style&index=0&id=46db14d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46db14d6"]])

export default __exports__